const table_full_width = () => {
    if ($('.table-full-width').length) {

        $('.table-full-width').each(function () {
            let $table = $(this);

            // When the window is resized...
            $(window).smartresize(function(){   
                setTableItemsHeight($table);
            })

            // set item height
            setTableItemsHeight($table);
        });

        function setTableItemsHeight($table) {
            $table.find('[data-row]').css('minHeight', '');
            let $tableCells = $table.find('[data-row]');

            $tableCells.each(function (i) {
                var row_n = $(this).data('row');
                var row_cells = $("[data-row=" + row_n + "]");
                var maxHeight = -1;

                row_cells.each(function (i) {
                    maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
                })

                row_cells.each(function (i) {
                    $(this).height(maxHeight)
                })

            });
        }
    }
}

(function($,sr){

    // debouncing function from John Hann
    // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
    var debounce = function (func, threshold, execAsap) {
        var timeout;
    
        return function debounced () {
            var obj = this, args = arguments;
            function delayed () {
                if (!execAsap)
                    func.apply(obj, args);
                timeout = null;
            };
    
            if (timeout)
                clearTimeout(timeout);
            else if (execAsap)
                func.apply(obj, args);
    
            timeout = setTimeout(delayed, threshold || 100);
        };
    }
    // smartresize 
    jQuery.fn[sr] = function(fn){  return fn ? this.on('resize', debounce(fn)) : this.trigger(sr); };
    
    })(jQuery,'smartresize');

export default table_full_width;